import { TableCell, TableRow } from '@repo/shadcn';
import { FC } from 'react';

import { DatePickerField, TextField } from '@components/form/fields';
import { DeleteButton } from '@components/ui/button';

import { formatCurrencyInBDT } from '../../../../utils';
import {
    TCreatePrePurchaseForm,
    TCreatePrePurchaseItem,
} from './create-pre-purchase.schema';

type CreatePurchaseItemProps = {
    item: TCreatePrePurchaseItem;
    serialNumber: number;
    onRemove: () => void;
};

export const CreatePurchaseItem: FC<CreatePurchaseItemProps> = ({
    item,
    serialNumber,
    onRemove,
}) => {
    const renderExpirationDate = () => {
        // return format(item.expiration_date ?? '', 'dd/MM/yyyy');

        return (
            // <DateInputField<TCreatePrePurchaseForm>
            //     name={`items.${serialNumber - 1}.expiration_date` as const}
            //     // inputClass={'w-32'}
            // />
            <div className="w-20 sm:w-24">
                <DatePickerField<TCreatePrePurchaseForm>
                    name={`items.${serialNumber - 1}.expiration_date` as const}
                    disableCalendar
                />
            </div>
        );
    };

    const renderQuantity = () => {
        return (
            <TextField<TCreatePrePurchaseForm>
                inputClass={
                    'h-7 w-12 text-[10px] text-right sm:h-8 sm:w-14 sm:text-xs'
                }
                name={`items.${serialNumber - 1}.quantity` as const}
            />
        );

        // return item.quantity;
    };

    const renderPurchasePrice = () => {
        return (
            <TextField<TCreatePrePurchaseForm>
                name={`items.${serialNumber - 1}.purchase_price` as const}
                inputClass={
                    'h-7 w-14 text-[10px] text-right sm:h-8 sm:w-16 sm:text-xs'
                }
            />
        );
    };

    const renderWholesalePrice = () => {
        return (
            <TextField<TCreatePrePurchaseForm>
                name={`items.${serialNumber - 1}.wholesale_price` as const}
                inputClass={
                    'h-7 w-14 text-[10px] text-right sm:h-8 sm:w-16 sm:text-xs'
                }
            />
        );
    };

    const renderRetailPrice = () => {
        return (
            <TextField<TCreatePrePurchaseForm>
                name={`items.${serialNumber - 1}.retail_price` as const}
                inputClass={
                    'h-7 w-14 text-[10px] text-right sm:h-8 sm:w-16 sm:text-xs'
                }
            />
        );
    };

    // const renderTotalPrice = () => {
    //     return formatCurrencyInBDT(item.purchase_price * item.quantity);
    // };

    return (
        <TableRow className={'rounded-md even:bg-white/70'}>
            <TableCell className="px-0.5 py-0.5 font-medium sm:px-1 sm:py-0.5">
                {serialNumber}
            </TableCell>
            <TableCell className="min-w-24 px-0.5 py-0.5 sm:min-w-28 sm:px-1 sm:py-0.5">
                {item.product_name}
            </TableCell>
            <TableCell className="relative px-0.5 py-0.5 sm:px-1 sm:py-0.5">
                {renderExpirationDate()}
            </TableCell>
            <TableCell className="px-0.5 py-0.5 text-right sm:px-1 sm:py-0.5">
                {renderQuantity()}
            </TableCell>
            <TableCell className="px-0.5 py-0.5 text-right sm:px-1 sm:py-0.5">
                {renderPurchasePrice()}
            </TableCell>
            <TableCell className="px-0.5 py-0.5 text-right sm:px-1 sm:py-0.5">
                {renderWholesalePrice()}
            </TableCell>

            <TableCell className="px-0.5 py-0.5 text-right sm:px-1 sm:py-0.5">
                {renderRetailPrice()}
            </TableCell>

            <TableCell className="whitespace-nowrap px-0.5 py-0.5 text-right sm:px-1 sm:py-0.5">
                {formatCurrencyInBDT(
                    (item.purchase_price ?? 0) * (item.quantity ?? 0),
                )}
            </TableCell>
            <TableCell className="px-0.5 py-0.5 text-right sm:px-1 sm:py-0.5">
                <DeleteButton isIconButton={true} onClick={onRemove} />
            </TableCell>
        </TableRow>
    );
};

CreatePurchaseItem.displayName = 'CreatePurchaseItem';
